/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Badge_CancelsInputs */



/**
* | output |
* | --- |
* | "Cancels at period end" |
*
* @param {Sub_Addons_Badge_CancelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_badge_cancels = /** @type {((inputs?: Sub_Addons_Badge_CancelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Badge_CancelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Endet zum Periodenende")
	return /** @type {LocalizedString} */ ("Cancels at period end")
});